import { api } from "./api";
import ShowNotifications from "../helper/ShowNotifications";

class WebsiteEnquiryApi {
  getWebsiteEnquiries = async (params) => {
    try {
      const response = await api.get("/website-enquiry", { params });
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      }
    } catch (error) {
      const errorMessage = error?.response?.data?.message || "Failed To Fetch Website Enquiries";
      ShowNotifications.showAlertNotification(errorMessage, false);
      return { status: false, response: error?.response?.data || error };
    }
  };

  deleteWebsiteEnquiry = async (id) => {
    try {
      const response = await api.delete(`/website-enquiry/${id}`);
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      }
    } catch (error) {
      const errorMessage = error?.response?.data?.message || "Failed To Delete Website Enquiry";
      ShowNotifications.showAlertNotification(errorMessage, false);
      return { status: false, response: error?.response?.data || error };
    }
  };
}

const websiteEnquiryApi = new WebsiteEnquiryApi();
export default websiteEnquiryApi;

export const {
  getWebsiteEnquiries,
  deleteWebsiteEnquiry
} = websiteEnquiryApi;
